import { BadgeId, BadgesStats } from '../Models';
import { WritingBadge } from './WritingBadge';

export default class EggBadge extends WritingBadge {
  public readonly id = BadgeId.egg;

  public evaluateIfAchieved = (stats: BadgesStats) => {
    return stats.pagesCount > 0;
  };
}



// WEBPACK FOOTER //
// ./src/containers/Badges/AllBadges/egg.ts